module.exports = __webpack_public_path__ + "img/csv.a38a21b5.png";